import UserConnection from 'models/connections/UserConnection';
import PagedCollection from 'collections/utils/PagedCollection';

let DEFAULT_LIMIT = 24,
    DEFAULT_METHOD = 'GET',
    DEFAULT_MUTED_STATUS = false;

export const DISPLAY_CONNECTIONS_LIMIT = 12;

export default PagedCollection.extend({
    model: UserConnection,

    backend: 'gcapi',

    baseUrl: function() {
        if (this.displayName === '') {
            return '/connection-service/connection/connections/pagination';
        }

        return `/connection-service/connection/connections/pagination/${this.displayName}`;
    },

    initialize: function(models, args) {
        if (typeof args.displayName === 'undefined') {
            throw 'Invalid profile display name in UserConnection.';
        }

        this.limit = args.limit || DEFAULT_LIMIT;
        this.verb = args.verb || DEFAULT_METHOD;
        this.displayName = args.displayName;
        this.connectionCount = args.connectionCount;
        this.displayMutedStatus = args.displayMutedStatus || DEFAULT_MUTED_STATUS;
        this.initializePagedCollection({
            verb: this.verb,
            limit: this.limit,
            appendMode: args.appendMode || false,
            totalLengthUpperBound: this.connectionCount ? this.connectionCount.value : undefined
        });
    },

    findConnection: function(displayName) {
        return this.find(function(connection) {
            return connection.get('displayName') === displayName;
        });
    },

    parse: function(response) {
        this.fullName = response.fullName;
        return response.userConnections;
    }
});
